import { render, staticRenderFns } from "./campaigns.vue?vue&type=template&id=498d12a2&scoped=true"
import script from "./campaigns.vue?vue&type=script&lang=js"
export * from "./campaigns.vue?vue&type=script&lang=js"
import style0 from "./campaigns.vue?vue&type=style&index=0&id=498d12a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498d12a2",
  null
  
)

export default component.exports